<template>
  <div :class="orderClass" @click="order">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    ordering: String
  },
  computed: {
    name_desc() {
      return '-' + this.name
    },
    orderClass() {
      return {
        sorting_asc: this.ordering === this.name,
        sorting_desc: this.ordering === this.name_desc
      }
    }
  },
  methods: {
    order() {
      let by = this.ordering === this.name ? this.name_desc : this.name
      this.$emit('order', by)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderBy.vue